
<template>
  <div class="footer">
    <div class="inner">
      <div class="footerTop">复印行业贴心的工具服务商</div>
      <div class="footerCentre inner">
        <div class="relation">
          <p>联系我们</p>
          <p>
            <i class="el-icon-phone-outline"></i>
            <a href="#">&nbsp;人工服务：13838272674</a>
            <a href="#">&nbsp;&nbsp;售后服务：0371-55075525</a>
          </p>
          <p>
            <i class="el-icon-location-information"></i>
            <a href="#">&nbsp;河南总部：河南省郑州市金水区文化北路锦艺金水湾观澜苑14号楼#3</a>
          </p>
          <!-- <p>
            <i class="el-icon-location-information"></i>
            <a href="#">&nbsp;网址：WWW.hnxiaohongmao.cn</a>
          </p> -->
        </div>
        <dl class="download">
          <dd>
            <p>小程序</p>
            <img src="@/assets/wx.jpg" alt>
          </dd>
          <dd>
            <p>关注公众号</p>
            <img src="@/assets/gzh.jpg" alt>
          </dd>
        </dl>
      </div>
      <div class="footerBott">copyright© 2016-2021 hnxiaohongmao.com 郑州沐之盛信息科技有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">豫ICP备18003125号-2</a> </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>
<style lang="less">
a {
  text-decoration: none;
  color: white;
}
.footer {
  height: 450px;
  color: white;
  background: url("../assets/footer.png") no-repeat;
  .inner {
    .footerTop {
      width: 350px;
      line-height: 55px;
      background: #e1372e;
      text-align: center;
      margin: 0 auto;
      position: relative;
      top: -27px;
      left: 0px;
    }
    .footerCentre {
      // background: salmon;
      display: flex;
      margin: 80px 0 80px 0;
      .relation {
        width: 1000px;
        p:nth-of-type(1) {
          width: 65px;
          // color: yellow;
          padding-bottom: 10px;
          font-size: 16px;
          border-bottom: 1px solid #999;
        }
        p:nth-of-type(2) {
          margin-top: 20px;
          line-height: 30px;
          font-size: 14px;
        }
        p:nth-of-type(3) {
          line-height: 30px;
          font-size: 14px;
        }
        p:nth-of-type(4) {
          line-height: 30px;
          font-size: 14px;
        }
      }
      .download {
        display: flex;
        dd {
          img {
            width: 82px;
            height: 82px;
            margin-top: 10px;
          }
        }
        dd:nth-of-type(1){
           margin-right: 80px;
        }
      }
    }
    .footerBott {
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>